import { render, staticRenderFns } from "./promotionList.vue?vue&type=template&id=6d2a5e3c&scoped=true"
import script from "./promotionList.vue?vue&type=script&lang=js"
export * from "./promotionList.vue?vue&type=script&lang=js"
import style0 from "./promotionList.vue?vue&type=style&index=0&id=6d2a5e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a5e3c",
  null
  
)

export default component.exports